import { openPostApi, postApi } from "./api";

const LOGIN_API = {
  method: "POST",
  url: "/users/sign-in",
};

const SIGNUP_API = {
  method: "POST",
  url: "/users/sign-up",
};

const SEND_VERIFICATION_CODE_API = {
  method: "POST",
  url: "/users/send-verify-code",
};

const CHECK_VERIFICATION_CODE_API = {
  method: "POST",
  url: "/users/check-verify-code",
};

const FIND_PASSWORD_API = {
  method: "POST",
  url: "/find-password",
};

const CHECK_PASSWORD_API = {
  method: "POST",
  url: "/users/check-password",
};

const CHANGE_PASSWORD_API = {
  method: "POST",
  url: "/users/change-password",
};

export const login = async (data) => {
  const requestBody = {
    email: data.email,
    password: data.password,
  };
  try {
    const response = await openPostApi(LOGIN_API.url, requestBody);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const signUp = async (data) => {
  const requestBody = {
    email: data.email,
    userName: data.name,
    password: data.password,
    hospitalName: data.hospitalName,
  };
  try {
    const response = await postApi(SIGNUP_API.url, requestBody);
    return response;
  } catch (error) {
    return error;
  }
};

export const sendVerificationCode = async (data) => {
  const requestBody = {
    email: data.userId,
  };
  try {
    const response = await openPostApi(SEND_VERIFICATION_CODE_API.url, requestBody);
    return response.data;
    
  } catch (error) {
    return error;
  }
};

export const checkVerificationCode = async (data) => {
  const requestBody = {
    email: data.userId,
    verifyCode: data.verifyCode,
  };
  try {
    const response = await openPostApi(CHECK_VERIFICATION_CODE_API.url, requestBody);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const findPassword = async (data) => {
  const requestBody = {
    userId: data.userId,
  };
  try {
    const response = await openPostApi(FIND_PASSWORD_API.url, requestBody);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const checkPassword = async (data) => {
  const requestBody = {
    email: data.email,
    password: data.password,
  };
  try {
    const response = await postApi(CHECK_PASSWORD_API.url, requestBody);
    return response.data;
  } catch (error) {
    return error;
  }
};


export const changePassword = async (data) => {
  const requestBody = {
    email: data.email,
    password: data.password,
  };
  try {
    const response = await postApi(CHANGE_PASSWORD_API.url, requestBody);
    return response.data;
  } catch (error) {
    return error;
  }
};